import { render, staticRenderFns } from "./khb.vue?vue&type=template&id=492ddd67&scoped=true&"
import script from "./khb.vue?vue&type=script&lang=js&"
export * from "./khb.vue?vue&type=script&lang=js&"
import style0 from "./khb.vue?vue&type=style&index=0&id=492ddd67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492ddd67",
  null
  
)

export default component.exports